import { UIElements } from '@ansvar-sakerhet/ui';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 1rem;
`;

const CheckboxRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  label {
    font-size: 14px;
    color: #1b1b1b;
  }
`;

const ProjectsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Label = styled.p`
  color: #1b1b1b;
  font-size: 14px;
  font-weight: 400;
`;

const ProjectList = styled.div`
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #cbcbcb;
  border-radius: 2px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const S = {
  ...UIElements,
  Container,
  CheckboxRow,
  ProjectsSection,
  Label,
  ProjectList,
};
